module.exports = __webpack_public_path__ + "img/marketing-icon-secure.364766b3.svg";